import React from "react";
import Image from "next/image";
import { Blur, Remote } from "@/api/loaderRemote";

const RuleItem = ({ rule }) => {
  return (
    <div className="flex items-center gap-3">
      <Image
        src={rule?.icon}
        width={36}
        height={36}
        loader={Remote}
        blurDataURL={Blur(rule?.icon)}
        className="object-contain"
        alt={rule?.baslik}
      />
      <span className="text-sm font-medium leading-normal text-themeBlack">
        {rule?.baslik}
      </span>
    </div>
  );
};

export default RuleItem;
